<template>
  <div>
    <div class="header">
      <el-page-header @back="goBack">
        <template #content>
          <span>{{ board_info.name }}</span>
          <span>{{ board_info.date }}</span>
          <span>{{ board_info.week }}</span>
          <span>{{ board_info.page_count }}张板书</span>
        </template>
      </el-page-header>

      <section>
        <el-button v-if="user_cate == 1" type="primary" class="delete" size="small" @click="batchDelete"><img
            src="@/assets/imgs/batch-deletion.png" alt="">
          批量删除</el-button>
        <el-button v-show="isShowCheckbox" type="danger" class="delete" size="small" @click="confirmDelete">
          删除</el-button>
        <el-button v-show="isShowCheckbox" class="delete" size="small" @click="cancleCheck"> 取消</el-button>
      </section>
    </div>
    <board ref="board" :listData="board_detail" :src_list="src_list" :type="'detail'" :isShowCheckbox="isShowCheckbox"
      @editName="editName">
      <template slot-scope="{data}">
        <div class="board-name" :title="data.name">{{ data.alias_name ? data.alias_name : data.name }}</div>
      </template>
    </board>
    <Dialog v-if="isShowDialog" :isShow="isShowDialog" @closeDialog="closeDialog" @confirm="confirm">
      <template #container>
        <img class="edit-img" :src="board_url" alt="">
        <span style="display: inline-block; text-align: left;">板书名称：</span>
        <el-input v-model="board_name"></el-input>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Board from './components/Board.vue'
import Dialog from '../../../components/dialog/Dialog.vue'
export default {
  components: { Board, Dialog },
  data () {
    return {
      board_id: '',
      board_info: {},
      board_name: '',
      before_update_name: '',
      page_id: '',
      board_detail: [],
      isShowDialog: false,
      board_url: '', //编辑名称查看到的图片
      isShowCheckbox: false,
      src_list: [] // 预览图片数组
    }
  },
  computed: {
    user_cate () {
      return localStorage.getItem('cate')
    }
  },
  mounted () {
    this.board_id = this.$route.query.id
    this.getBoardDetail()
  },
  methods: {
    async getBoardDetail () {
      const { data: res } = await this.$axios.post('/base/board/detail', { board_id: this.board_id })
      if (res.errCode == 0) {
        const { date, name, week, page_count } = res.data
        this.board_info = { date, name, week, page_count }
        this.board_name = res.data.name
        this.board_detail = res.data.pages
        this.board_detail.forEach(item => {
          //把name的值赋值给新键名
          item.board_url = item.thumbnail
          // 图片预览
          this.src_list.push(item.page)
          //然后把旧的键名删除
          delete (item.thumbnail)
        })
      }
    },
    // 编辑板书集名称
    editName (data) {
      const { id, name, alias_name, board_url } = data
      this.before_update_name = alias_name || name
      this.board_url = board_url
      this.board_name = alias_name || name
      this.page_id = id
      this.isShowDialog = true
    },
    // 确认修改板书集名称
    async confirm () {
      if (!this.board_name) {
        this.$message.warning('板书名称不能为空！')
        return false
      }
      if (this.before_update_name == this.board_name) {
        return false
      }
      const { data: res } = await this.$axios.post('/base/board/update/page', { page_id: this.page_id, name: this.board_name })
      if (res.errCode === 0) {
        this.$message.success(res.message)
        this.isShowDialog = false
        this.getBoardDetail()
      } else {
        this.$message.error(res.message)
      }
    },
    // 关闭弹窗
    closeDialog () {
      this.isShowDialog = false
    },
    // 批量删除板书
    batchDelete () {
      this.isShowCheckbox = true
    },
    async confirmDelete () {
      const deleteBord = this.$refs.board.checkedBoard.join(',')
      const { data: res } = await this.$axios.post('base/board/del/page', {
        board_id: this.board_id,
        page_name: deleteBord
      })
      if (res.errCode === 0) {
        this.$message.success(res.message)
        this.isShowCheckbox = false
        this.$nextTick(() => {
          this.$refs.board.checkedBoard = []
          this.getBoardDetail()
        })

      } else {
        console.log(res.message)
      }
    },
    cancleCheck () {
      this.isShowCheckbox = false
      this.$refs.board.checkedBoard = []
    },
    goBack () {
      this.$router.go(-1)
    }
  }

}
</script>

<style lang="scss" scoped>
.el-page-header {
  margin: 20px 0;

  .el-page-header__left {
    color: #92B7D6;
  }

  .el-page-header__content {
    span {
      font-size: 16px;
      color: #1B2422;

      &:nth-child(1) {
        margin-right: 40px;
        font-weight: bold;
      }

      &:nth-child(2) {
        margin-right: 10px;
      }

      &:nth-child(3) {
        margin-right: 40px;
      }
    }
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .delete {
    img {
      margin-top: -3px;
      vertical-align: middle;
    }
  }
}

.board-name {
  height: 48px;
  line-height: 42px;
  text-align: center;
}


/deep/ .el-dialog__body {
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    text-align: left;
  }
}

.edit-img {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/banshu/details.vue